import Vue from 'vue';
import Vuex from 'vuex';

import { modalModule } from 'vuex-modal';
import OptionsModule from '../global/module/options.vuex';
import ServiceModule from '../global/module/services.vuex';
import BookingModule from '../global/booking/module/booking.vuex';
import BookingDetailModule from '../global/booking/module/bookingdetail.vuex';
import Navigation from '../global/module/navigation.vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
		modal: modalModule,
		options: OptionsModule,
		services: ServiceModule,
		booking: BookingModule,
		bookingdetail: BookingDetailModule,
		navigation: Navigation
    }
});

export default store;
